// extracted by mini-css-extract-plugin
module.exports = {"link":"LinkComponent_link__hzVDd","icon":"LinkComponent_icon__odvVH"};